import React from "react";
import "./getLoading.css";

const GetLoading = () => {
  return (
    <div className="custom-loader-container">
      <div className="custom-spinner"></div>
      <img
        src="/images/logo_votmean_app.png"
        alt="Logo"
        className="custom-spinner-logo"
      />
    </div>
  );
};

export default GetLoading;
